import { standardRatios } from '@hub/frame'
import { clamp } from 'lodash'
import { SGPageTemplateImage } from '../../../../types/page-templates'

const MAX_IMAGE_WIDTH = 1200
const MIN_IMAGE_WIDTH = 300
const URL_PREFIX = 'https://res.cloudinary.com/scentre-group-au/image/fetch/'
const RESIZE_MODES = {
  'crop-face': 'c_fill,q_auto,g_faces:auto',
  'crop-center': 'c_fill,q_auto,g_center',
  pad: 'c_pad,b_auto',
}

function getWidth(): number {
  const maxResizeWidth =
    typeof window === 'undefined'
      ? MAX_IMAGE_WIDTH
      : clamp(window.innerWidth, MIN_IMAGE_WIDTH, MAX_IMAGE_WIDTH)

  return Math.max(maxResizeWidth, MIN_IMAGE_WIDTH)
}

function getHeight(
  width: number,
  currentRatio?: string | number | null
): number {
  const imageRatio =
    typeof currentRatio === 'string'
      ? standardRatios[currentRatio]
      : currentRatio ?? 1

  return Math.floor(width / imageRatio)
}

export default function makeImageUrl(
  preferredImage: SGPageTemplateImage,
  currentRatio?: string | number | null,
  currentResizeMode?: 'crop-face' | 'crop-center' | 'pad' | null
): string {
  const width = getWidth()
  const height = getHeight(width, currentRatio)

  const cloudinaryResizeMode = RESIZE_MODES[currentResizeMode ?? 'crop-face']
  const cropOptions = [
    cloudinaryResizeMode,
    `w_${width},h_${height},dpr_2`,
    'f_auto',
  ]

  const preferredImageUrl = preferredImage.url.startsWith('//')
    ? `https://${preferredImage.url}`
    : preferredImage.url

  return `${URL_PREFIX}${cropOptions.join(',')}/${preferredImageUrl}`
}
